import React from 'react';

const Spinner = () => (
  <div className="spinner">
    <div className="child" />
    <div className="child second-bounce" />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js